import ViewMenu from './ViewMenu';

export default ViewMenu;